module.exports = __webpack_public_path__ + "img/EmptyCoupons.863d7227.png";